import type { SidebarNavigationItem } from "~/types/sidebar.types";
import { Briefcase, Building2, User, BarChart3, ShieldCheck } from "lucide-react";

export const NAVIGATION_ITEMS: SidebarNavigationItem[] = [
    { name: "My Applications", href: "/dashboard", icon: Briefcase },
];

// Organization item shown separately (needs org context)
export const ORG_ITEM: SidebarNavigationItem = {
    name: "My Organisation",
    href: "/my-organisation",
    icon: Building2,
};

// University stats item shown for UNIVERSITY_ADMIN role only
export const UNIVERSITY_STATS_ITEM: SidebarNavigationItem = {
    name: "Statistics",
    href: "/statistics",
    icon: BarChart3,
};

// University access management item shown for UNIVERSITY_OWNER role only
export const UNIVERSITY_ACCESS_ITEM: SidebarNavigationItem = {
    name: "Access Management",
    href: "/access-management",
    icon: ShieldCheck,
};

export const SETTINGS_ITEMS: SidebarNavigationItem[] = [
    { name: "My Account", href: "/account", icon: User },
];